<template lang="pug">
v-container.tabs-management.pa-8(fluid)
    v-row
      v-col
        h2.primary--text {{ $t('Portal.fieldLabeling') }}
    v-row
      v-col
        div(
          v-for="(field, index) in fields",
          :key="field.name",
        )
          extra-field-editor(
            :field="field",
            :value="getFieldValue(field.name)",
            @change="input",
          )
          v-divider(v-if="index != (fields.length - 1)")
</template>

<script>
import ExtraFieldEditor from "./ExtraFieldEditor";

export default {
  components: {
    ExtraFieldEditor,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    }
  },
  data: () => ({}),
  methods: {
    getFieldValue(fieldName) {
      return this.value.find(f => f.name === fieldName);
    },
    input({ event, field }) {
      let copyValue = [...this.value];
      copyValue = copyValue.filter(f => f.name !== field.name);

      if (event) {
        copyValue.push({ ...field });
      }

      this.$emit('input', copyValue);
    },
  },
}
</script>
